const TABLE = {
  limit: 'Résultats par page',
};

export default TABLE;
